export default function() {
  const widgetName = 'infoCards';
  const widgetOpts = infoCardsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: 'BUY TIX'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $(`#${widgetName} .card-widget-item`).each(function(i, item){
        const title = $(this).find('.card-widget-title');
        const titleText = title.text();
        const characterLimit = 41;

        if (titleText.length > characterLimit) {
          const trimmedText = titleText.substring(0, characterLimit);
          title.text(trimmedText);
        }

        let d = data.items[i];
        let dateText = d.DateRange;

        if (dateText !== null) {
          $(`<span class="card-widget-date">${dateText}</span>`).prependTo(this);
        }

        const trimmedDate = $(this).find('.card-widget-date');
        const dateMonth = trimmedDate.text().slice(0, 3);
        const dateDay = trimmedDate.text().slice(4, 7).replace(',', '');
        trimmedDate.text(dateMonth);
        trimmedDate.append(`<span class='day'>${dateDay}</span>`);
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 0,
      nav: true
    },
    textOverImage: false
  });

}